export default __webpack_public_path__ + "static/media/logodesktop.85ac386e.png";